export const getStateFromElement = (element) => ({
    target: element.dataset.bsTarget,
    toggle: element.dataset.bsToggle,
});

const SESSION_STORAGE_KEY_NAME = 'bootstrap_modules_controller';

export const getState = () => {
    const obj = sessionStorage.getItem(SESSION_STORAGE_KEY_NAME) || JSON.stringify({});
    const parsedObj = JSON.parse(obj);

    return parsedObj;
};

export const setState = (key, value) => {
    const obj = sessionStorage.getItem(SESSION_STORAGE_KEY_NAME) || JSON.stringify({});

    const parsedObj = JSON.parse(obj);

    parsedObj[key] = value;

    sessionStorage.setItem(SESSION_STORAGE_KEY_NAME, JSON.stringify(parsedObj));
};

export const removeState = (key) => {
    const obj = sessionStorage.getItem(SESSION_STORAGE_KEY_NAME) || JSON.stringify({});

    const parsedObj = JSON.parse(obj);

    delete parsedObj[key];

    sessionStorage.setItem(SESSION_STORAGE_KEY_NAME, JSON.stringify(parsedObj));
};

export const clearState = () => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY_NAME);
};
